import React, { FC } from 'react';
import { useParams } from 'react-router';
import SubNavigationLayout from './SubNavigationLayout';
import { useBundleDetails } from '../../api/bundles/useBundleDetails';
import './BundleDetailNavigation.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
    readonly isSticky: boolean;
};

export const BundleDetailNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { bundleId = '' } = useParams<'bundleId'>();
    const { data: bundle } = useBundleDetails(bundleId);

    return (
        <SubNavigationLayout
            left={
                <ul className="bundle-detail-nav">
                    <li>
                        <a
                            className="back-button"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <i className="material-icons bigger">arrow_back</i>
                        </a>
                    </li>
                    <li>
                        <span>{t('menu.shop.languages.curatedCollections')}</span>
                    </li>
                    <li>
                        <i className="material-icons big">keyboard_arrow_right</i>
                    </li>
                    <li>{bundle?.title ?? ''}</li>
                </ul>
            }
            isSticky={isSticky}
            width="50"
        />
    );
};
